import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container';

import '../Components/BuyNowCard/buyCard.css'
import tickimg from '../img/checked.png'
import untickimg from '../img/unchecked.png'
import cat from '../img/22.png';
import './home.css'





const BuyCard = (props) => {
  return (
    <div  style={{backgroundColor:"#ffffff",borderBottom:'1px solid black'}} id="roadmap">
      <Container className="py-5 my-5">
        <h1 className="pcc---section-main-heading pb-5">Roadmap</h1>
       <div className="">
       <img  src={cat} className="img-fluid" style={{width: '91px',height: '91px'}} style={{

    height: '108px',
    position: 'absolute',
    /* left: -4px; */
    /* right: 95px; */
    /* z-index: 0; */
    transition: 'transform 0.2s ease',
    transform: 'translateY(-71px) translateX(-176px)',
}}/>

    <Grid
      container
      direction="row"
      xs={12}
      sm={12}
      className=" text-left px-2 my-3 my-md-0 py-5 position-relative  "
      style={{backgroundColor:'#dcdcdc'}}
      
    >
    
    <Grid
      container
      direction="column"
      justify="left"
      xs={12}
      sm={4}
      className=""
    >
     
        <div
          className="mx-3 para" >
             <h4 style={{width:'100%',backgroundColor:'#fdd53b',color:'black'}} class="text-center py-2">Q1</h4>
            <div className="  " >
            <p className="mb-2 mt-4" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />Project introduction</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />Coingecko listing</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />Dev AMA from launch</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />First Holder Rewards</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />AMA to red room</p>
            </div>
            
          </div>
    </Grid>
    <Grid
      container
      direction="column"
      justify="left"
      xs={12}
      sm={4}
      className=" "
    >
     
        <div
          className="mx-3 para" >
             <h4 style={{width:'100%',backgroundColor:'#fdd53b',color:'black'}} class="text-center py-2">Q2</h4>
            <div className="" >
            <p className="mb-2 mt-4" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />Website update</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />CoinTiger listing</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />CERTIK Audit</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={tickimg} className="img-fluid mr-3"   />AMA to OD</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />AMA to BSC lovers</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />Coinzilla ads</p>
            </div>
            
          </div>
    </Grid>
    <Grid
      container
      direction="column"
      justify="left"
      xs={12}
      sm={4}
      className=" "
    >
     
        <div
          className="mx-3 para" >
             <h4 style={{width:'100%',backgroundColor:'#fdd53b',color:'black'}} class="text-center py-2">Q3</h4>
            <div className="" >
            <p className="mb-2 mt-4" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />YouTube videos</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />Tiktok videos</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />In talks with vetted ads on poocoin</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />Locker</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />Video Game</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />Coin Market Cap listing</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />Coin Market Cal listing</p>
            <p className="mb-2 mt-2" style={{fontSize:'21px'}}><img src={untickimg} className="img-fluid mr-3"   />LunarCrush</p>
            </div>
            
          </div>
    </Grid>
    </Grid>
    </div> 
    </Container>
    </div>
    
    
  );
}

export default BuyCard;
